import { SitemapPage } from '../../../../pages_components/sitemap/SitemapPage';
import { getSitemapPageServerSidePropsFactory } from '../../../../pages_components/sitemap/SitemapPage/getServerSide';

export const getServerSideProps = getSitemapPageServerSidePropsFactory(
    'Popular Course Searches on Cademy',
    'Discover the most popular course topics and searches on Cademy',
    'CategoryOrTagSearchPages',
    1000
);

export default SitemapPage;
